export const CONFIG = {
  institutionalLink: 'https://institutional.huma.finance',
  linkedInLink: 'https://www.linkedin.com/company/huma-finance',
  discordLink: 'https://discord.gg/29zVxZ6kCN',
  youtubeLink: 'https://www.youtube.com/@humafinance',
  twitterLink: 'https://twitter.com/humafinance',
  githubLink: 'https://github.com/00labs',
  telegramLink: 'https://t.me/HumaFinanceCommunity',
  whitepaperLink: 'https://huma-finance.gitbook.io/huma-2.0',
  lendingPoolLink: 'https://docs.huma.finance/#4.0-lending-protocol',
  devGuideLink:
    'https://docs.huma.finance/developer-guidelines/getting_started',
  dspDevGuideLink:
    'https://docs.huma.finance/developer-guidelines/decentralized_signal_portfolio',
  eaDevGuideLink:
    'https://docs.huma.finance/developer-guidelines/evaluation_agent',
  termsOfServiceLink: '#/termsOfUse',
  privacyPolicyLink: '#/privacyPolicy',
  careersLink: '',
  blogLink: 'https://blog.huma.finance',
  contactLink: 'mailto:hi@huma.finance',
  partnerLink:
    'https://uer4clyybno.typeform.com/humapartner?typeform-source=landing',
  auditLink:
    'https://www.halborn.com/audits/huma-finance/solana-programs-060022',
  permissionlessLink: 'https://app.huma.finance/',
  vimeoVideo: 'http://vimeo.com/1074109657',
  youtubeVideo: 'https://youtu.be/52pOCYmcYtQ?vq=hd1080',
}
